<template lang="pug">
form.signUp(:class="styleData")
    slot(name="title")
    //- h2 週年慶活動結束囉！
    //- p.text-center
    //-     span.drawingPoint 英文能力分析報告
    //-     | ＆英檢題庫
    //-     br
    //-     | 再抽
    //-     span.drawingPoint 不限航點來回機票
    .signUp-form
        .signUp-input
            .icon
                img(src="@/assets/anniversary_2023/icon/person.svg" alt="person")
                img(src="@/assets/anniversary_2023/ribbons/icons/person.svg" alt="person")
            input(type="text" v-model="formUpper.parentName" placeholder="家長姓名 (必填)")
        .signUp-input
            .icon
                img(src="@/assets/anniversary_2023/icon/phone.svg" alt="phone")
                img(src="@/assets/anniversary_2023/ribbons/icons/phone.svg" alt="phone")
            input(type="text" v-model="formUpper.parentPhone" placeholder="家長手機 (必填)")
        .signUp-input
            .icon
                img(src="@/assets/anniversary_2023/icon/mail.svg" alt="mail")
                img(src="@/assets/anniversary_2023/ribbons/icons/mail.svg" alt="mail")
            input(type="text" v-model="formUpper.parentEmail" placeholder="家長信箱 (必填)")
        .materials
            div(class="w-50")
                img(class="w-100" src="@/assets/anniversary_2023/form/career.svg" alt="career")
            div(class="w-50")
                img(class="w-100" src="@/assets/anniversary_2023/form/ticket.svg" alt="ticket")
        .privacy
            input(type="checkbox" class="d-none" id="privacy" v-model="formUpper.privacyPolicyCheck")
            label(for="privacy")
                | 我同意 WUWOW 線上英文
                router-link(:to="{path:privacyUrl}",target="_blank") 隱私權政策
    button(class="signUp-btn" disabled type="button" @click="submitForm(formUpper)") 活動已經結束囉！
    p.contactNumber
        span 0800 885 315
        | 撥打專線，立即有專人為您服務
</template>

<script>
import lioshutanApi from '@/api';
import { checkEmailFormat, checkPhoneFormat } from '@/utils/verify';
import { getEventMediaSource } from '@/utils/mediaSourse';
import httpCodeConstants from '@/constants/httpCode';
import { alertFailedMessage } from '@/utils/sweetAlert.js';

export default {
  name: 'SingForm',

  props: {
    styleData: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      privacyUrl: '/privacy',
      formUpper: {
        parentName: '',
        parentPhone: '',
        parentEmail: '',
        privacyPolicyCheck: true,
      },
    };
  },

  methods: {
    fieldCheck(email, phone, privacyPolicyCheck, formdata) {
      // let fulfilled = true;
      // Object.values(formdata).forEach((data) => {
      //   if (data === '') {
      //     fulfilled = false;
      //   }
      // });
      // if (!fulfilled) {
      //   alertFailedMessage('似乎還有些欄位尚未填寫完畢');
      //   return false;
      // }

      // 只檢查家長姓名
      if (!formdata.parentName) {
        alertFailedMessage('請留下留下您姓名');
        return false;
      }
      if (!checkEmailFormat(email)) {
        alertFailedMessage('可以再幫我確認一次您的電子郵件帳號嗎');
        return false;
      }
      if (!checkPhoneFormat(phone)) {
        alertFailedMessage('可以再幫我確認一次您的電話號碼嗎');
        return false;
      }
      if (!privacyPolicyCheck) {
        alertFailedMessage('可以再幫我確認一下隱私權政策及學習約定條款嗎');
        return false;
      }
      return true;
    },
    getNoteInfo(formdata) {
      let noteInfo = '';

      const queryGid = this.$route.query.gid;
      if (queryGid) {
        noteInfo += `gid=${queryGid} `;
      }

      // 必填
      if (formdata.parentName) {
        noteInfo += `學員家長姓名: ${formdata.parentName}`;
      }
      // 選填
      // if (formdata.studentChineseName) {
      //   noteInfo += ` | 學員中文姓名: ${formdata.studentChineseName}`;
      // }
      // if (formdata.studentEnglishName) {
      //   noteInfo += ` | 學員英文姓名: ${formdata.studentEnglishName}`;
      // }
      // if (formdata.studentAge) {
      //   noteInfo += ` | 學員年齡: ${formdata.studentAge}`;
      // }
      return noteInfo;
    },
    hasLeaveMessage() {
      localStorage.setItem('hasWritedPhone', true);
    },
    async submitForm(formdata) {
      const fieldChecked = this.fieldCheck(formdata.parentEmail, formdata.parentPhone, formdata.privacyPolicyCheck, formdata);
      if (fieldChecked) {
        const mediaSource = getEventMediaSource(this.$route.path, this.$route.query);
        const noteInfo = this.getNoteInfo(formdata);
        const params = {
          name: formdata.parentName, // 原為學生姓名，改為家長中文姓名
          phone: formdata.parentPhone, // jr丟入家長的電話
          email: formdata.parentEmail, // jr丟入家長的email
          note: noteInfo, // 其餘資訊總和
          media_source: mediaSource,
        };
        const result = await lioshutanApi.common.setMediaSource(params);
        // if (result.data.data === 'freecoins_cvq') {
        //   this.savePhoneNumber(params.phone);
        // } else if (result.data.data == null && localStorage.getItem('setFreecoinsCvq')) {
        //   localStorage.removeItem('setFreecoinsCvq');
        // }
        if (result.status === httpCodeConstants.SUCCESS) {
          this.hasLeaveMessage();
          console.log(this.$route.query.m);
          switch (true) {
            case this.$route.query.m === 'eric_thank_you':
              this.$router.push({ name: 'anniversary-eric-thank' });
              break;
            case /ad__eric/.test(this.$route.query.m):
              this.$router.push({ name: 'anniversary-eric-thank' });
              break;
            case /eric/.test(this.$route.query.m):
              this.$router.push({ name: 'anniversary-eric-thank' });
              break;
            default:
              this.$router.push({ name: 'anniversary-thank' }); // 通往感謝頁
              break;
          }
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../style.scss';

.signUp {
    border-radius: 20px;
    background: #fff;
    padding: 20px;

    @include md {
        width: 100%;
        max-width: 500px;
        margin: 0 auto;
        padding: 27px;
    }

    @include lg {
        // max-width: 480px;
        // width: 480px;
        flex-grow: 1;
        flex-shrink: 0;
    }

    @include xl {
        flex-shrink: 0;
    }

    >h2 {
        text-align: center;
        font-weight: 900;
        font-size: 18px;
        line-height: 26.1px;
        margin-bottom: 20px;
        @include rwd-font(18px, 28px, 28px);
        @include rwd-lh(145%, 135%, 135%);
    }

    >p {
        font-weight: 700;
    }
}

.drawingPoint {
    display: inline-block;
    position: relative;
    background: linear-gradient(transparent 60%, #FFCB15 80%, transparent 100%, );
}

.signUp-input {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #FFCB15;
    border-radius: 5px;
    overflow: hidden;
    margin-bottom: 27px;

    input {
        appearance: none;
        border: none;
        outline: none;
        padding: 8px 6px;
        flex-grow: 1;
    }
}

// 2AB291
.green .signUp-input {
    border: 1px solid #2AB291;
}

.icon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    border-right: 1px solid #FFCB15;
    img:first-child {
        display: block;
    }
    img:last-child {
        display: none;
    }
}

.green .icon {
    border-right: 1px solid #2AB291;
    img:first-child {
        display: none;
    }
    img:last-child {
        display: block;
    }
}

.materials {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.privacy {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #505050;
    line-height: 150%;
    margin-bottom: 24px;
    cursor: pointer;

    a {
        color: #FFCB15;
        font-size: 14px;
    }

    label {
        cursor: pointer;
        display: flex;
        align-items: center;
        position: relative;
        user-select: none;
    }

    label::before {
        content: '';
        display: inline-block;
        width: 15px;
        height: 15px;
        border-radius: 2px;
        margin-right: 4px;
        margin-bottom: 0;
        border: 1px solid #505050;
    }

    input:checked~label::before {
        background: #FF9700;
        border: 1px solid #FF9700;
    }

    label::after {
        content: '';
        position: absolute;
        display: inline-block;
        width: 6px;
        height: 10px;
        left: 6px;
        top: 50%;
        border-right: 2px solid white;
        border-bottom: 2px solid white;
        transform: translate(-23%, -68%) rotate(45deg);
    }
}

.green .privacy {
    a {
        color: #2AB291;
    }

    input:checked~label::before {
        background: #2AB291;
        border: 1px solid #2AB291;
    }
}

.signUp-btn {
    appearance: none;
    border: none;
    outline: none;
    background: #000;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    border-radius: 25px;
    background: #FFCB15;
    color: #fff;
    padding: 10px 0;

    &:hover {
        background: lighten(#FFCB15, 10%);
    }
    &:disabled {
        background: rgba(205, 205, 205, 1);
    }
}

.green .signUp-btn {
    background: #2AB291;

    &:hover {
        background: lighten(#2AB291, 10%);
    }
    &:disabled {
      background: rgba(205, 205, 205, 1);
    }
}

.signUp>.contactNumber {
    margin-top: 20px;
    text-align: center;
    font-weight: 400;
    font-size: 13px;
    letter-spacing: 0.84px;

    span {
        color: #FFCB15;
        margin-right: 10px;
    }
}
.signUp.green >.contactNumber span{
    color: #2AB291;
}
</style>
